/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ClearanceCaseRowDataSourceDto {
  public id: number = undefined;
  public index: number = undefined;
  public articleId: string = undefined;
  public articleNumber: string = undefined;
  public statnrSe: string = undefined;
  public statnrNo: string = undefined;
  public additionalCode1: string = undefined;
  public additionalCode2: string = undefined;
  public additionalCode3: string = undefined;
  public reducedTaxNo: boolean;
  public chassisNumber: string = undefined;
  public goodsMarking: string = undefined;
  public packageCount: number = undefined;
  public packageCategoryCode: string = undefined;
  public description: string = undefined;
  public originCountryCode: string = undefined;
  /**
   * Avsändning fylke, only used for norwegian exports
   */
  public originCountyId: number = undefined;
  public grossWeight: number = undefined;
  public sePreferenceCode: string = undefined;
  public noPreferenceCode: string = undefined;
  public cUSCode: string = undefined;
  public netWeight: number = undefined;
  public afsStatus: boolean;
  public vatCode: number = undefined;
  public euGoods: boolean;
  public freightExchangeRate: number = undefined;
  public textileLicenseAmount: number = undefined;
  public textileLicenseNumber: string = undefined;
  public quotas: string = undefined;
  public forceOtherQuantity: boolean;
  public forceOtherQuantityNo: boolean;
  /**
   * Shows unit from Statnr by default
   */
  public otherQuantityId: number = undefined;
  public otherQuantityUnitNo: string = undefined;
  public otherQuantity: number = undefined;
  public otherQuantityNo: number = undefined;
  public price: number = undefined;
  public valueDeterminationSe: string = undefined;
  public valueDeterminationNo: string = undefined;
  public importProcedureId: number = undefined;
  public exportProcedureId: number = undefined;
  public importProcedureAddonCode: string = undefined;
  public exportProcedureAddonCode: string = undefined;
  public adjustment: number = undefined;
  public statisticalValue: number = undefined;
  public customsWarehouseCode: string = undefined;
  public customsWarehouseType: string = undefined;
  public customsWarehouseCountry: string = undefined;
}
